import client from './client';

interface ServerInfo {
  ftp: {
    host: string;
    port: number;
  };
}

export const serverInfoApi = {
  get: () => client.get<ServerInfo>('/server-info').then((r) => r.data),
};
